export default __webpack_public_path__ + "static/media/lsd-ilustracao.0ffa1e6e.webp";